import { ChangeDetectorRef, Component, Input, OnInit, EventEmitter, Output } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { HomeService } from "../home.services";
import * as FileSaver from "file-saver";
import { RegulatoryInfoService } from "./regulatory-info.service";
import { environment } from "src/environments/environment.prod";
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
  selector: "app-regulatory-info",
  templateUrl: "./regulatory-info.component.html",
  styleUrls: ["./regulatory-info.component.scss"],
})
export class RegulatoryInfoComponent implements OnInit {
  @Input() MolData: any;
  @Input() ActiveIngred: any;
  @Input() BrandName: any;
  @Input() NDAnumber: any;
  @Input() saveOldData: any;
  @Output() regulatoryHeaderUpdated = new EventEmitter<string>();
  selectedFiles: Map<any, any> = new Map();
  fileNames: Map<any, any> = new Map();
  initialPdfPaths: Map<any, string> = new Map();

  Molecule: boolean;
  secondSectionData: any;
  links = 'window.open("http://43.205.223.1:8000';
  DragData: any = {};
  typeArray = ["paraI", "paraII", "paraIII", "paraIV"];
  newArray = [];
  contentTableArray = [];
  popupcontents: any;
  contentPopups = "none";
  content_Details: [];
  content_value: "";
  sliceEnd = 5;
  contentKey = "";
  displaypopup = "none";
  data: [][];
  refEditData = {};
  submolecules: any[];
  subMolecule = false;
  selectedSubMolecule: any;
  searchValue = "";
  noData = false;
  showedit = false;
  tempData: any = {};
  changed_Cols: [];
  nullmessage: any = "";
  tablekeys: string[];
  tableData: any = [];
  tablevalues: any = [];
  colorcode: {};
  // #headerid/
  setWidth: any;
  objectKeys = Object.keys;
  objectValues = Object.values;
  linkURL: any;
  paramsValues: any;
  editedData: any;
  storedData: any;
  keysArray: Array<String> = [];
  keyIds: Array<String> = [];
  showCheckBox = false;
  options: any = [];
  thirdSectionData: any = {};
  fourthSectionData: any = {};
  ApiInformationData: any = {};
  FormulationData: any = {};
  CompetitiveData: any = {};
  ExecutiveData: any = {};
  activeIngredientforPI: any;
  uniqNumber: any;
  UserIp: any;
  email: any;
  ShowLmsMessage: any;
  fieldInformation: any;
  displayReviewDialog: boolean = false;
  selectedKey: string = '';
  selectedEmail: any;
  reviewComment: string = '';
  emailList: any[] = [];
  drugName: any;
  drugActiveIngredient: any;
  drugNdaNumber: any;
  drugDosageForm: any;
  submitted: boolean = false; // Track form submission
  verificationMessage: string = '';
  guidanceList: any;
  public Editor = ClassicEditor;
  public editorData = '<p>Type your content here...</p>';

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  isObject(value: any): boolean {
    return value && typeof value === 'object' && !Array.isArray(value);
  }

  isobjectKeys(row: any) {
    return Object.keys(row);
  }

  constructor(
    private regulatoryInfoService: RegulatoryInfoService,
    private ref: ChangeDetectorRef,
    public toastr: ToastrService,
    private route: ActivatedRoute,
    private homeservice: HomeService,
    private sanitized: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.uniqNumber = this.route.snapshot.queryParams["uniqnumber"];
    this.UserIp = localStorage.getItem("ipaddress");
    this.email = localStorage.getItem("email");
    this.fetchEmails();
    this.paramsValues = this.route.snapshot.queryParams;
    if (
      this.paramsValues.active_ingredient &&
      this.paramsValues.brand_name &&
      this.paramsValues.ndaValue &&
      this.paramsValues.section
    ) {
      this.getEditedChanges(
        this.paramsValues.active_ingredient,
        this.paramsValues.brand_name,
        this.paramsValues.ndaValue,
        this.UserIp,
        this.uniqNumber,
        this.email
      );
      this.Molecule = true;
    } else {
      this.getregulatoryInfo();
    }
  }

  getregulatoryInfo() {
    let active_ingredient = this.ActiveIngred;
    let brand_name = this.BrandName;
    let ndaValue = this.NDAnumber;
    let sectionThree = "regulatory_information_details";
    const base64Encode = (str: string): string => {
      return btoa(unescape(encodeURIComponent(str)))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=+$/, '');
    };

    const encodedActiveIngredient = base64Encode(active_ingredient);
    const encodedBrandName = base64Encode(brand_name);
    this.linkURL = `${environment.ip}/#/home?active_ingredient=${encodedActiveIngredient}&brand_name=${encodedBrandName}&ndaValue=${ndaValue}&section=${sectionThree}`;
    // this.linkURL = `http://3.111.249.237/#/home?active_ingredient=${active_ingredient}&brand_name=${brand_name}&ndaValue=${ndaValue}&section=${sectionThree}`;
    this.regulatoryInfoService
      .getThirdSection(active_ingredient, brand_name, ndaValue)
      .subscribe((sec: any) => {
        this.Molecule = true;
        this.ShowLmsMessage = sec?.['status_message']
        this.colorcode = sec.data["REGULATORY INFORMATION"]["colorindicator"];
        this.fieldInformation = sec.data["REGULATORY INFORMATION"]["field_information"];
        console.log("fieldInformation", this.fieldInformation)
        this.fetchBeGuidance();
        this.checkFieldVerificationStatus();

        setTimeout(() => {
          // Emit the updated header with verification status
          const updatedHeader = this.verificationMessage; // Updated message
          console.log("Emitting:", updatedHeader); // Debugging the emission
          this.regulatoryHeaderUpdated.emit(updatedHeader);  // Emit updated header value to parent
        }, 1000);
        this.DragData = sec.data["REGULATORY INFORMATION"];
        this.tempData = sec.data["REGULATORY INFORMATION"];
        let RefStandardData = this.DragData["Reference Standard (RS)"];

        if (
          Array.isArray(RefStandardData) &&
          RefStandardData.some((item) => Array.isArray(item) && item.length > 0)
        ) {
          console.log("here");
          RefStandardData = RefStandardData.filter(
            (item) => Array.isArray(item) && item.length > 0
          );

          // Remove empty objects
          RefStandardData = RefStandardData.filter(
            (item) => typeof item === "object" && Object.keys(item).length > 0
          );

          // Update the original data
          this.DragData["Reference Standard (RS)"] = RefStandardData;
        } else {
          console.log("innn");
          // Set it to an empty array if it doesn't meet the condition
          this.DragData["Reference Standard (RS)"];
        }
      });
  }

  checkFieldVerificationStatus() {
    // Start with the default message
    let verificationMessage = 'REGULATORY INFORMATION';

    // Iterate over each section (key) in fieldInformation
    for (const section in this.fieldInformation) {
      if (this.fieldInformation.hasOwnProperty(section)) {
        // Check if any item in the current section has field_verified as false
        const unverifiedField = this.fieldInformation[section].some(item => item.field_verified === false || item.field_verified === "N/A");

        if (unverifiedField) {
          // Add HTML span for highlighting the pending verification part
          verificationMessage += " - Verification of field is pending";
          break; // Stop after the first match (you can continue checking all sections if needed by removing this line)
        }
      }
    }

    // Store the final message (HTML)
    this.verificationMessage = verificationMessage;

    // Optionally, log the verification message
    console.log(this.verificationMessage);
  }

  showArray(data, n2, n3, n4, n5, n6, n7) {
    this.contentPopups = "block";
    this.contentTableArray = data;
  }
  Selectparam(event) {
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = this.saveOldData//JSON.parse(referdata);
    let brand_name: any;
    brand_name = moleculedata["Brand Name/Proprietary Name"];
    let obj = {
      type: event.target.value,
      brand_name: moleculedata["Brand Name/Proprietary Name"],
    };
    this.homeservice.addPara(obj).subscribe((res) => { });
  }

  showLess(data, n2, n3, n4, n5, n6, n7) {
    this.contentPopups = "block";
    this.tablekeys = Object.keys(data[0]);
    this.tablevalues = data;
  }

  /**
   *
   * @param InputProperty  value entered
   * @param Objectvalue     object values of the keys in an object
   * @returns
   */
  getcolorcode(InputProperty: string, Objectvalue: any): any {
    if (Objectvalue[InputProperty] !== undefined) {
      return Objectvalue[InputProperty];
    } else {
      return "";
    }
  }
  /**
   * Method to handle search
   */

  getEditedValues() {
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = JSON.parse(referdata);
    let active_ingredient = moleculedata["Active Ingredient"];
    let brand_name = moleculedata["Brand Name/Proprietary Name"];
    let ndaNumber = moleculedata["NDA number"];
    this.getEditedChanges(
      active_ingredient,
      brand_name,
      ndaNumber,
      this.UserIp,
      this.uniqNumber,
      this.email
    );
  }

  getEditedChanges(
    active_ingredient: string,
    brand_name: string,
    ndaNumber: number,
    userIp: string,
    uniqnumber: number,
    email: string
  ) {
    this.regulatoryInfoService
      .getEditedData(
        active_ingredient,
        brand_name,
        ndaNumber,
        userIp,
        uniqnumber,
        email
      )
      .subscribe((res: any) => {
        if (this.paramsValues.section === "regulatory_information_details") {
          this.DragData = res.previously_updated_db_data;
          this.storedData = res.data.edited_data_key_insert_to_db;
        }
      });
  }

  isChanged(key): any {
    this.keysArray = [];
    if (this.storedData) {
      Object.keys(this.storedData).map((keys) => {
        if (keys === key) {
          this.keysArray.push(keys);
        }
      });
      return this.keysArray;
    }
  }

  /**
   * Robustly parses a date string into a Date object.
   * Supports: DD/MM/YYYY, DD-MM-YYYY, YYYY-MM-DD, MM/DD/YYYY, and ISO strings.
   */
  parseDate(dateStr: any): Date | null {
    if (!dateStr || dateStr === 'N/A') return null;
    if (dateStr instanceof Date) {
      return isNaN(dateStr.getTime()) ? null : dateStr;
    }
    const str = String(dateStr).trim();
    // DD/MM/YYYY or DD-MM-YYYY
    const ddmmyyyy = str.match(/^(\d{1,2})[\/-](\d{1,2})[\/-](\d{4,5})$/); // Allow up to 5 digits for year just in case
    if (ddmmyyyy) {
      const d = new Date(+ddmmyyyy[3], +ddmmyyyy[2] - 1, +ddmmyyyy[1]);
      if (!isNaN(d.getTime())) return d;
    }
    // YYYY-MM-DD or YYYY/MM/DD
    const yyyymmdd = str.match(/^(\d{4})[\/-](\d{1,2})[\/-](\d{1,2})/);
    if (yyyymmdd) {
      const d = new Date(+yyyymmdd[1], +yyyymmdd[2] - 1, +yyyymmdd[3]);
      if (!isNaN(d.getTime())) return d;
    }
    // Fallback to native parse (handles ISO 8601 & MM/DD/YYYY)
    const fallback = new Date(str);
    return isNaN(fallback.getTime()) ? null : fallback;
  }

  formatDate(dateVal: any): string {
    if (!dateVal || dateVal === 'N/A') return 'N/A';
    const date = this.parseDate(dateVal);
    if (!date) return dateVal;

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = months[date.getMonth()];
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month} ${day}, ${year}`;
  }

  formatPayloadDate(dateVal: any): string {
    if (!dateVal || dateVal === 'N/A') return 'N/A';
    const date = this.parseDate(dateVal);
    if (!date) return dateVal;
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  editbtn() {
    this.showedit = !this.showedit;
    if (this.showedit === true) {
      this.sliceEnd = 1000;
      const beGuidanceKey = 'FDA product specific BE guidance';

      if (!Array.isArray(this.DragData[beGuidanceKey]) && this.guidanceList && this.guidanceList.length > 0) {
        // Build the editable rows from the guidance list (first time entering edit mode)
        this.DragData[beGuidanceKey] = this.guidanceList.map(item => {
          const path = (item.pdf_url && item.pdf_url !== 'N/A') ? item.pdf_url : (item.s3_url !== 'N/A' ? item.s3_url : 'N/A');
          const dateValue = this.parseDate(item.date);
          const row = { Date: dateValue, PDF: path };
          this.initialPdfPaths.set(row, path);
          return row;
        });
        this.DragData = { ...this.DragData };
        this.tempData = { ...this.DragData };
      } else if (Array.isArray(this.DragData[beGuidanceKey])) {
        // Already an array (e.g. re-entering edit mode): ensure all Date values are Date objects
        this.DragData[beGuidanceKey].forEach(row => {
          if (row['Date'] && !(row['Date'] instanceof Date)) {
            row['Date'] = this.parseDate(row['Date']);
          }
        });
        this.DragData = { ...this.DragData };
        this.tempData = { ...this.DragData };
      }
    } else {
      this.sliceEnd = 5;
    }
  }

  downloadFiles() {
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = this.saveOldData//JSON.parse(referdata);
    this.homeservice
      .getdownloadfile({
        nda_number: moleculedata["NDA number"],
        brand_name: moleculedata["Brand Name/Proprietary Name"],
      })
      .subscribe((res) => {
        let resp = res["data"]["content"];
        let file = res["data"]["filename"];
        FileSaver.saveAs(
          `data:application/vnd.ms-excel;base64,${resp}`,
          `${file}`
        );
      });
  }

  // Hide and show checboxes
  downloadSelected() {
    this.showCheckBox = !this.showCheckBox;
  }
  // Selecting the checkbox
  selected_checbox(event: any, index: number) {
    if (!this.options.includes(event)) {
      this.options = [...this.options, event];
    } else {
      this.options = this.options.filter((item) => item !== event);
    }
  }
  // Download based on selected items
  downloadSelectedData() {
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = this.saveOldData//JSON.parse(referdata);
    let columns_data = this.options;
    this.homeservice
      .downloadSelected({
        nda_number: moleculedata["NDA number"],
        brand_name: moleculedata["Brand Name/Proprietary Name"],
        columns_data,
      })
      .subscribe((res) => {
        let resp = res["data"]["content"];
        let file = res["data"]["filename"];
        FileSaver.saveAs(
          `data:application/vnd.ms-excel;base64,${resp}`,
          `${file}`
        );
      });
  }

  closecontentpopup() {
    // if (event === 'cancel') {

    this.content_Details = [];
    this.tableData = [];
    this.tablekeys = [];
    this.content_value = "";
    this.contentKey = "";
    this.contentPopups = "none";
    this.contentTableArray = [];
    // }
  }

  addClickEvent(event, value, key) {
    if (
      key === "Dosage and Administration" ||
      key === "Recommended dose" ||
      key === "Indications and Usage"
    ) {
      this.contentPopups = "block";
      this.content_Details = value;
      this.contentKey = key;
      this.content_value = "";
    } else if (
      key === "Variability (% ISCV)" ||
      key === "PK Linearity" ||
      key === "Food effect" ||
      key === "Pharmacology"
    ) {
      this.contentPopups = "block";
      this.content_Details = [];
      this.contentKey = key;
      this.content_value = value;
    } else {
      this.contentPopups = "none";
      this.content_Details = [];
      this.contentKey = "";
      this.content_value = "";
    }
    // if(event.type === 'mouseleave'){
    //   this.contentPopups = 'none';
    //   this.content_Details = [];
    //   this.contentKey ='';
    //   this.content_value ='';
    // }
  }


  addTable(data, n4, n5, n6, n7) {
    let objdata: any = this.DragData;
    console.log("this.objdata before", n7);

    if (n7 === 'FDA product specific BE guidance') {
      objdata[n7] = [];
      let newRow = { "Date": null, "PDF": "" };
      objdata[n7].push(newRow);
    } else {
      if (Array.isArray(objdata[n7])) {
        objdata[n7] = [];
      } else if (typeof objdata[n7] === 'string') {
        objdata[n7] = [];
      } else {
        objdata[n7] = [];
      }

      let headers;
      switch (n7) {
        case 'Petitions filed':
          headers = ["Docket No", "Petitioner", "Product Name/Issue", "Category", "Petition Type", "Receipt Date",
            "Decision Date", "Decision", "Comments"];
          break;
        default:
          headers = ["Default Header 1", "Default Header 2"];
          break;
      }

      // Create a new row based on the defined headers
      let newRow = {};
      headers.forEach(header => {
        newRow[header] = "Cell " + (Object.keys(newRow).length + 1);
      });
      objdata[n7].push(newRow);
    }

    this.DragData = { ...objdata };
    console.log("this.DragData after", this.DragData);
    this.tempData = { ...objdata };
  }

  deleteTable(key: string) {
    let objdata: any = this.DragData;

    if (objdata.hasOwnProperty(key)) {
      objdata[key] = "N/A";
    }

    this.DragData = { ...objdata };
    this.tempData = { ...objdata };

    console.log("Table deleted for key:", key);
  }

  addItems(data, n2, n3, n4, n5, n6, n7) {
    console.log(data);
    let objdata: any = this.DragData;
    let obj = {};
    let keys: string[];
    if (data && data.length > 0 && data[0]) {
      keys = Object.keys(data[0]);
    } else if (n7 === 'FDA product specific BE guidance') {
      keys = ['Date', 'PDF'];
    } else {
      keys = ['Default Header 1', 'Default Header 2'];
    }
    // For BE guidance, new rows get correct empty defaults
    if (n7 === 'FDA product specific BE guidance') {
      obj = { Date: null, PDF: '' };
    } else {
      for (let i = 0; i <= keys.length - 1; i++) {
        obj[keys[i]] = "";
      }
    }
    if (!Array.isArray(objdata[n7])) {
      objdata[n7] = [];
    }
    objdata[n7].push(obj);
    this.DragData = { ...objdata };
    this.tempData = { ...objdata };
    this.ref.markForCheck();
  }

  addListItem(data, n4, n5, n6, n7) {
    if (
      n7 === "Reference Standard (RS)" &&
      Array.isArray(this.DragData[n7]) &&
      this.DragData[n7].length === 0
    ) {
      // If "Filed ANDA" is an empty array, push an empty array to it
      this.DragData[n7].push([]);
    } else {
      let objdata: any = this.DragData;
      if (typeof objdata[n7] === 'string') {
        objdata[n7] = [objdata[n7]];
      }
      let arr = [];
      console.log("Arrayyyy", objdata[n7].push(arr));
      this.DragData = { ...objdata };
      this.tempData = { ...objdata };
    }
  }

  // addListItem(data, n4, n5, n6, n7) {
  //   let objdata: any = this.DragData;
  //   if (typeof objdata[n7] === 'string') {
  //     console.log('Keyy:', objdata[n7]);
  //     objdata[n7] = [objdata[n7]];
  //     console.log("onjjjjjjj", objdata[n7]);
  //   }
  //   let arr = [];
  //   console.log("Arrayyyy", objdata[n7].push(arr));
  //   this.DragData = { ...objdata };
  //   console.log('Updated DragData:', this.DragData);
  //   this.tempData = { ...objdata };
  // }


  deleteListItem(value: any, key: any, index: number) {
    console.log("deleteItemmm", value, index);
    let objdata: any = this.DragData;
    if (value.length > 1) {
      value.splice(index, 1);

      const keysToConvert = ['NCE-1 date (dd-mm-yyyy)', 'Reference Listed Drug (RLD)', 'Reference Standard (RS)',
        'Orphan Drug Exclusivity', 'FDA product specific BE guidance', 'Eligible for CGT exclusivity*',
        'Additional Comments on Regulatory Information', 'Petitions filed', 'Possibility of Petition'];

      // Convert back to string if only one item left
      if (value.length === 1 && keysToConvert.includes(key)) {
        if (this.DragData[key]) {
          this.DragData[key] = value[0];
        }
      }

      this.DragData = { ...objdata };
    }
  }

  deleteRow(Obj: any, index: number) {
    let objdata: any = this.DragData;
    if (index > -1 && index < Obj.length) {
      Obj.splice(index, 1);
      console.log("deleteRow", Obj, index);
      // If all rows removed, set back to 'N/A' string
      if (Obj.length === 0) {
        // Find which key this array belongs to
        for (const key of Object.keys(objdata)) {
          if (objdata[key] === Obj) {
            objdata[key] = 'N/A';
            break;
          }
        }
      }
      this.DragData = { ...objdata };
    }
  }


  // ** We can edit the data based on object,array and array of objects */
  editdata(event, arr, keys, trows, rd, Obj, index, varikey, n9, n10) {
    if (Obj !== undefined) {
      if (this.tempData[keys] && Obj.value) {
        this.tempData[keys].map((res, j) => {
          Obj.value.map((resp, j1) => {
            if (j === index && j === j1) {
              let objkey = Object.keys(Obj.value[0]);
              let uniquekey = objkey[n10];
              resp[uniquekey] = event.target.value;
            }
          });
        });
      }
    }
    if (Obj === "lItems") {
      if (Array.isArray(this.tempData[keys])) {
        this.tempData[keys].map((respp, k) => {
          if (arr) {
            arr.map((resps, p) => {
              if (p === rd) {
                if (resps === trows) {
                  arr[rd] = event.target.value;
                }
              }
            });
          } else {
          }
        });
      }
    } else if (Obj === undefined) {
      this.tempData[keys] = event.target ? event.target.value : event;
      // this.tempData[keys] = event.target.value;
    }
    console.log('Updated tempData:', this.tempData);
  }


  saveEdit() {
    this.sliceEnd = 5;
    this.showedit = !this.showedit;
    let referdata: any = localStorage.getItem("molecules");
    let moleculedata: any = this.saveOldData//JSON.parse(referdata);
    let editedData: any = {};
    editedData["edited_data"] = this.tempData;
    editedData["nda_number"] = moleculedata["NDA number"];
    editedData["brand_name_proprietary_name"] =
      moleculedata["Brand Name/Proprietary Name"];
    editedData["active_ingredient"] = moleculedata["Active Ingredient"];
    editedData["link"] = this.linkURL;
    editedData["email"] = this.email;

    // Ensure BE guidance dates are strings before sending to API
    const beGuidanceKey = 'FDA product specific BE guidance';
    if (this.tempData[beGuidanceKey]) {
      const rows = Array.isArray(this.tempData[beGuidanceKey])
        ? this.tempData[beGuidanceKey]
        : [this.tempData[beGuidanceKey]];
      rows.forEach(row => {
        if (row['Date'] && row['Date'] instanceof Date) {
          row['Date'] = this.formatPayloadDate(row['Date']);
        }
      });
    }

    console.log(editedData);
    this.regulatoryInfoService
      .SendEmail(
        editedData["active_ingredient"],
        editedData["brand_name_proprietary_name"],
        editedData["nda_number"],
        editedData["email"],
        editedData
      )
      .subscribe((res: any) => {
        if (res && res.error && res.error === "Pending in LMS. Please take actions first; then editing will be allowed.") {
          this.toastr.error(res.error, "Error", {
            timeOut: 10000,   // Toast duration in milliseconds
            positionClass: 'toast-top-right',  // Position the toast in the top-right corner
            closeButton: true
          });
        }
      });
  }

  handelAction(key, flag, i) {
    let updatedValue = {
      nda_number: this.paramsValues.ndaValue,
      field: key,
      flag,
      brand_name: this.paramsValues.brand_name,
      active_ingredient: this.paramsValues.active_ingredient,
      userip: localStorage.getItem("ipaddress"),
      uniqnumber: this.uniqNumber,
      email: localStorage.getItem("email"),
    };
    this.regulatoryInfoService
      .updateMoleculeData(updatedValue)
      .subscribe((res: any) => {
        if (flag === "accept") {
          this.keyIds.push(key.key);
          document.getElementById(key.key).style.display = "none";
          this.toastr.success("Data updated sucessfully", "");
        } else {
          this.DragData = res.old_data_with_updated_set;
          this.keyIds.push(key.key);
          setTimeout(() => {
            this.keyIds.forEach((id: String) => {
              document.getElementById(`${id}`).style.display = "none";
            });
          }, 0);
          this.toastr.error("Data rejected sucessfully", "");
        }
      });
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitized.bypassSecurityTrustHtml(html);
  }

  openPdf(value) {
    // let url: any = window.open(`http://3.111.95.5/pm_backend//${value}`);
    let url: any = window.open(`${environment.ip}pm_backend//${value}`);
    return this.sanitized.bypassSecurityTrustHtml(url);
  }


  getTooltipContent(key: string): string {
    if (this.fieldInformation && this.fieldInformation[key]) {
      return this.fieldInformation[key]
        .map(
          (item: any) =>
            `Source: ${item.source} <br> 
             LMS No: ${item.lms_unique_no} <br> 
             Approved By: ${item.field_approved_by} <br> 
             Last Update: ${item.last_update_date} <br> 
             Last Verified By: ${item.last_verified_by || "N/A"} <br> 
             Last Reviewed By: ${item.Last_reviewed_by || "N/A"} <br> 
             Last Verified Date: ${item.last_verified_date || "N/A"} <br> 
             Last Reviewed Date: ${item.last_reviewed_date || "N/A"}`
        )
        .join("<br><br>"); // Double <br> for spacing between items
    }
    return "No information available";
  }

  openReviewDialog(key: string) {
    this.selectedKey = key;
    this.displayReviewDialog = true;
  }

  fetchEmails() {
    this.homeservice.getUserMailId(this.email).subscribe(
      (response: any) => {
        console.log("API Response:", response);

        if (response && response.data) {
          this.emailList = response.data.map(item => ({ label: item.email, value: item.email })); // Correct format for p-dropdown
        } else {
          this.emailList = [];
        }

        console.log("Formatted Emails for Dropdown:", this.emailList);
      },
      error => {
        console.error("Error fetching emails:", error);
      }
    );
  }



  isCommentValid(): boolean {
    return this.selectedEmail && this.reviewComment.length >= 15;
  }

  submitReview() {
    this.submitted = true;
    if (!this.selectedEmail || !this.reviewComment || this.reviewComment.length < 15) {
      this.toastr.error("Please enter at least 15 characters in the comment.", "Error");
      return;
    }

    const reviewData = {
      user_mail: this.email,
      reviewer_email: this.selectedEmail,       // Email of the reviewer
      comment: this.reviewComment,     // Review comment (at least 15 chars)
      field: this.selectedKey,         // Field that is being reviewed
      section: "REGULATORY INFORMATION",   // Hardcoded section name
      drugBrandName: this.BrandName,         // Brand Name from API response
      drugNdaNumber: this.NDAnumber,   // NDA Number from API response
      // drugDosageForm: this.drugDosageForm  // Dosage Form from API response
    };

    console.log('Submitting:', reviewData);

    this.homeservice.submitFieldReview(reviewData).subscribe(
      (response) => {
        console.log("Review submitted successfully:", response);
        this.toastr.success("Reviewed field successfully", "Success");
        this.reviewComment = '';
        this.selectedEmail = '';
        this.displayReviewDialog = false;
        this.fieldInformation[this.selectedKey][0].field_reviewed = true; // Disable Review button
        this.fieldInformation[this.selectedKey][0].field_verified = false;
      },
      (error) => {
        console.error("Error submitting review:", error);
        this.toastr.error("Failed to submit review. Try again.", "Error");
      }
    );
  }

  verifyField(fieldKey: string) {
    const fieldInfo = this.fieldInformation[fieldKey];

    if (!fieldInfo) {
      this.toastr.error('Field information not found!', 'Error');
      return;
    }

    if (fieldInfo.field_verified) {
      this.toastr.info('Already Verified!', 'Info');
      return;
    }

    const payload = {
      user_mail: this.email,
      field_key: fieldKey,
      nda_number: this.NDAnumber,             // NDA Number from API response
      brand_name: this.BrandName,             // Brand Name from API response
    };

    console.log("Payload for verification:", payload);

    this.homeservice.verifyFieldData(payload).subscribe(
      (response) => {
        // console.log("Review submitted successfully:", response);
        this.toastr.success("Field verified successfully", "Success");
        this.fieldInformation[fieldKey][0].field_verified = true;
        this.fieldInformation[fieldKey][0].field_reviewed = false;

        // this.getpatentInfo();
      },
      (error) => {
        console.error("Failed to verify field", error);
        this.toastr.error("Failed to verify field. Try again.", "Error");
      }
    );
  }

  fetchBeGuidance() {
    const brand = this.BrandName;
    const nda = this.NDAnumber;

    this.homeservice.getAllBeGuidance(brand, nda).subscribe(
      (response: any) => {
        console.log("API Response:", response);

        if (response && response.results) {
          this.guidanceList = response.results;

          // Also sync with DragData so the specialized table can show it in View Mode
          const beGuidanceKey = 'FDA product specific BE guidance';
          if (this.guidanceList.length > 0) {
            this.DragData[beGuidanceKey] = this.guidanceList.map(item => {
              const path = (item.pdf_url && item.pdf_url !== 'N/A') ? item.pdf_url : (item.s3_url !== 'N/A' ? item.s3_url : 'N/A');
              const row = {
                Date: this.parseDate(item.date),
                PDF: path
              };
              this.initialPdfPaths.set(row, path);
              return row;
            });
            this.DragData = { ...this.DragData };
          }
        } else {
          this.guidanceList = [];
        }

        console.log("Formatted Guidance List:", this.guidanceList);
      },
      error => {
        console.error("Error fetching BE Guidance:", error);
      }
    );
  }

  openBEGuidancePDF(path: string) {
    if (!path || path === 'N/A') return;
    const fileName = path.split('/').pop();
    const url = `${environment.ip}pm_backend/info/get_be_guidance_pdf/?pdf_file_name=${fileName}`;
    window.open(url, '_blank');
  }

  onFileSelected(event: any, row: any, Obj: any, key: any): void {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const binaryString = e.target.result;
        const base64String = btoa(binaryString);

        // Store file metadata locally
        this.selectedFiles.set(row, file);
        this.fileNames.set(row, file.name);

        // Update row data for payload
        row['file'] = base64String;
        const brand = this.BrandName || 'BRAND';
        const nda = this.NDAnumber || 'NDA';
        row['PDF'] = `/media/BE_Guidance_pdf_folder/${nda}_${brand}.pdf`;

        this.ref.markForCheck();
      };
      reader.readAsBinaryString(file);
    }
  }

  onNA(row: any, Obj: any, key: any): void {
    if (row['PDF'] === 'N/A') {
      // Restore initial path if it exists
      row['PDF'] = this.initialPdfPaths.get(row) || '';
      delete row['file'];
      this.selectedFiles.delete(row);
      this.fileNames.delete(row);
    } else {
      row['PDF'] = 'N/A';
      delete row['file'];
      this.selectedFiles.delete(row);
      this.fileNames.delete(row);
    }
  }

}
